import React from 'react';
import drug from 'assets/icons/drugs.svg';

function SidePaneToggleIcon() {
  return <img src={drug} alt='' width={18} height={18} />;
}

export default SidePaneToggleIcon
